import { useBloc as useBlocNext } from "@blac/react";
import React from "react";
import AppViewCubit from "src/state/AppViewCubit/AppViewCubit";
import { DebugCheckbox } from "./debug.styles";

const DebugPartnerSession = () => {
  const [state, bloc] = useBlocNext(AppViewCubit);

  return (
    <div>
      <DebugCheckbox>
        <input
          type="checkbox"
          checked={!!state.partnerSession}
          onChange={() => bloc.togglePartnerSession()}
        />
        <span>Simulate Transcarent Session</span>
      </DebugCheckbox>
      <DebugCheckbox>
        <input
          type="checkbox"
          checked={!!state.partnerStyles}
          onChange={() => bloc.togglePartnerStyles()}
        />
        <span>Apply Partner Theme</span>
      </DebugCheckbox>
    </div>
  );
};

export default DebugPartnerSession;
